import React, { useState, useEffect, useRef } from "react";
import "../../style/filtersorting.css"; 

const DynamicFilter = ({ filterOptions, onFilterChange, currentFilter, placeholder, data }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState(currentFilter || []); 
    const dropdownRef = useRef(null); 

    console.log('sss filterUpcomingMeeting', data, currentFilter, filterOptions, selectedFilters)

    // Group filters into categories
    const groupedFilters = filterOptions.reduce((acc, option) => {
        const category = option.category || "Other"; // Default category if none provided
        if (!acc[category]) acc[category] = [];
        acc[category].push(option);
        return acc;
    }, {});

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleFilterSelection = (filterKey) => {
        console.log('sss filterUpcomingMeeting handleFilterSelection')
        const updatedSelectedFilters = selectedFilters.includes(filterKey)
            ? selectedFilters.filter(key => key !== filterKey)
            : [...selectedFilters, filterKey];
            
        setSelectedFilters(updatedSelectedFilters);

        const filteredData = updatedSelectedFilters.length > 0
            ? data.filter(item => updatedSelectedFilters.some(key => {
                const filterOption = filterOptions.find(option => option.key === key);
                return filterOption ? filterOption.filterCondition(item) : true;
            }))
            : data;

        onFilterChange(filteredData, updatedSelectedFilters);
    };

    // Re-apply filters when data changes
    useEffect(() => {
        if (selectedFilters.length > 0) {
            console.log('sss filterUpcomingMeeting handleFilterSelection Data changed, re-applying filters');
            const filteredData = data.filter(item => selectedFilters.some(key => {
                const filterOption = filterOptions.find(option => option.key === key);
                return filterOption ? filterOption.filterCondition(item) : true;
            }));
            onFilterChange(filteredData, selectedFilters);
        } else {
            // If no filters are selected, pass the original data
            onFilterChange(data, selectedFilters);
        }
    }, [data]); // This effect runs whenever 'data' changes

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="filter-container" ref={dropdownRef}>
            <button onClick={toggleDropdown} className="filter-icon">
                <img src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/myTaskFilterLineIcon.svg" />
            </button>

            {dropdownOpen && (
                <div className="dropdown">
                  {
                    placeholder && <p
                      style={{
                          fontWeight: "400",
                          fontSize: "14px",
                          lineHeight: "100%",
                          color: "#888888",
                          marginBottom: "5px",
                      }}
                    >{placeholder}</p>
                  }
                    <ul>
                        {Object.entries(groupedFilters).map(([category, options]) => (
                            <React.Fragment key={category}>
                                {category !== "Other" && <p className="filter-category">{category.toUpperCase()}:</p>}
                                {options.map(option => (
                                    <li key={option.key}>
                                        <label className="filter-option" option-key={option.key}>
                                            <input
                                                type="checkbox"
                                                checked={selectedFilters.includes(option.key)}
                                                onChange={() => handleFilterSelection(option.key)}
                                            />
                                            <span>{option.label}</span>
                                        </label>
                                    </li>
                                ))}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default DynamicFilter;
